import React, { Component, PropTypes } from 'react';
import ReactSparkTextInput from '../../../widgets/ReactSparkTextInput';
import { connect } from 'react-redux';
import { onThemePropChange, parseUrlProperty } from '../../../helpers/ThemeStoreHelpers';
import { RemFilter } from '../../../helpers/RemFilter';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import ModalAssetBrowser from '../../../widgets/ModalAssetBrowser';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import store from '../../../../store/Store';
import { Service as FileService } from '../../../../services/Service';
import { CATEGORIES } from '../../../../services/fileUpload/uploadFile';

class LogoStyles extends Component {
    render() {
        let widthFilter = new RemFilter(this.props.header.logo.width),
            heightFilter = new RemFilter(this.props.header.logo.height);
        return (
            <div>
                <br />
                <h4>Logo</h4>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="row">
                            <div className="col-xs-12 col-sm-3">
                                <ReactSparkTextInput
                                    label="Width (px)"
                                    isDisabled={this.props.isDisabled}
                                    value={widthFilter.original.px.value}
                                    onChange={this.props.onDimensionChange('width', widthFilter)}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-3">
                                <ReactSparkTextInput
                                    label="Height (px)"
                                    isDisabled={this.props.isDisabled}
                                    value={heightFilter.original.px.value}
                                    onChange={this.props.onDimensionChange('height', heightFilter)}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-3">
                                <ReactSparkTextInput
                                    label="Size"
                                    isDisabled={this.props.isDisabled}
                                    value={this.props.header.logo.size}
                                    onChange={this.props.onThemePropChange('size')}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-3">
                                <ReactSparkTextInput
                                    label="Position"
                                    isDisabled={this.props.isDisabled}
                                    value={this.props.header.logo.position}
                                    onChange={this.props.onThemePropChange('position')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <h4>Logo url</h4>
                <div className="row">
                    <div className="col-xs-11 col-sm-11">
                        <ReactSparkTextInput
                            label="Logo url"
                            isDisabled={this.props.isDisabled}
                            value={parseUrlProperty(this.props.header.logo.url)}
                            onChange={e => {
                                e.target.value
                                    ? this.props.onThemePropChange('url')(`url(${e.target.value})`)
                                    : this.props.onThemePropChange('url')('');
                            }}
                        />
                    </div>
                    <div className="col-xs-1 col-sm-1">
                        <ModalAssetBrowser
                            category={CATEGORIES.IMAGE}
                            isDisabled={this.props.isDisabled}
                            store={store}
                            onSelect={assets => {
                                if (assets.length >= 1) {
                                    let asset = assets[0];
                                    this.props.onThemePropChange('url')(
                                        `url(${FileService.assetUrl(
                                            asset.chainid,
                                            asset.hotelid,
                                            null,
                                            this.props.level,
                                            asset.filename,
                                            false,
                                            CATEGORIES.IMAGE
                                        )})`
                                    );
                                }
                            }}
                        />
                    </div>
                </div>
                <br />
                <h4>Hotel Name</h4>
                <div className="row">
                    <div className="col-xs-12">
                        <ConfigurationCheckbox
                            isDisabled={this.props.isDisabled}
                            value={this.props.theme.header.alwaysShowHotelName}
                            code="header.alwaysShowHotelName"
                            onChange={code =>
                                this.props.onRootThemePropChange(code)(!this.props.theme.header.alwaysShowHotelName)
                            }
                            title="Always Show Hotel Name"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapHeaderStylesStateToProps = (state, ownProps) => ({
    header: state.app.data.theme.header,
    theme: state.app.data.theme,
    level: state.app.selected.level
});

const mapHeaderStylesDispatchToProps = dispatch => ({
    onDimensionChange: (themeProperty, filter) => event =>
        dispatch(
            ThemeActions.modifyThemeKey(
                `header.logo.${themeProperty}`,
                filter.filter(parseInt(event.target.value || 0, 10) + 'px')
            )
        ),
    onThemePropChange: onThemePropChange(dispatch, 'header.logo'),
    onRootThemePropChange: onThemePropChange(dispatch, null)
});

export default connect(mapHeaderStylesStateToProps, mapHeaderStylesDispatchToProps)(LogoStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/LogoStyles.js